import React from "react";
import { Box, Hidden, Typography } from "@material-ui/core";
import { graphql } from "gatsby";
import { ContentHeroFragment as Props } from "./__generated__/ContentHeroFragment";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import {
  CaptionLabelText,
  ImgWrapper,
  LabelTextWrapper,
  SubtitleTextWrapper,
  WhiteBackButton
} from "./styles";

const ContentHero: React.FunctionComponent<Props> = ({
  heroBackground,
  heroBackgroundMobile,
  backButtonLinkPath,
  backButtonLabel,
  title,
  subtitle,
  labelPublished,
  labelTimeToRead
}) => {
  return (
    <Box
      display="flex"
      position="relative"
      zIndex={1}
      justifyContent="space-around"
    >
      <Box height={{ xs: "400px", md: "595px" }} width="1280px">
        <Box
          display="flex"
          height="100%"
          flexDirection="column"
          justifyContent="space-between"
          paddingTop={{ xs: 2.7, md: 5.5 }}
          paddingLeft={{ xs: 2, sm: 4, md: 6, lg: 0 }}
          paddingBottom={{ xs: 4, md: 8 }}
        >
          <Box position="absolute" zIndex={-1} top={0} left={0} right={0}>
            <picture>
              <source
                media="(min-width: 900px)"
                srcSet={heroBackground.url}
                sizes="700px"
              />
              <source
                media="(min-width: 200px)"
                srcSet={heroBackgroundMobile.url}
                sizes="400px"
              />
              <ImgWrapper src={heroBackground.url} />
            </picture>
          </Box>
          <Box width="100%">
            <WhiteBackButton to={backButtonLinkPath}>
              {backButtonLabel}
            </WhiteBackButton>
          </Box>
          <Box width="100%">
            <Box
              maxWidth={{ xs: "218px", sm: "350px", md: "680px" }}
              color="#FFFFFF"
            >
              <LabelTextWrapper>
                <Box display="flex" alignItems="center" marginRight="8px">
                  <AccessTimeIcon fontSize="small" />
                </Box>
                <CaptionLabelText>
                  {labelTimeToRead.toUpperCase()}
                </CaptionLabelText>
                <Hidden implementation="css" smDown>
                  <Box display="flex">
                    <Box
                      display="flex"
                      alignItems="center"
                      margin="0 10px"
                      fontSize="6px"
                    >
                      <FiberManualRecordIcon fontSize="inherit" />
                    </Box>
                    <CaptionLabelText>
                      {labelPublished.toUpperCase()}
                    </CaptionLabelText>
                  </Box>
                </Hidden>
              </LabelTextWrapper>
              <Typography color="inherit" variant="h3">
                {title}
              </Typography>
              <Box paddingTop="21px" maxWidth="459px">
                <Hidden implementation="css" mdUp>
                  <Typography variant="body2">{subtitle}</Typography>
                </Hidden>
                <Hidden implementation="css" smDown>
                  <SubtitleTextWrapper>{subtitle}</SubtitleTextWrapper>
                </Hidden>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export const ContentHeroFragment = graphql`
  fragment ContentHeroFragment on DatoCmsCModuleContentHero {
    backButtonLabel
    backButtonLinkPath
    labelPublished
    labelTimeToRead
    title
    subtitle
    heroBackground: background {
      url
    }
    heroBackgroundMobile: backgroundMobile {
      url
    }
    container
    containerDisableGutters
    containerBackgroundColor
    model {
      id
      apiKey
    }
  }
`;

export default React.memo(ContentHero);
